export const filterCreator = (appointment: any) => {
  let action = appointment?.actions?.find((a: any) => a.action === "CREADO" || a.action === "SOLICITADO");
  
  return action?.email || '---';
}